// Extracts a comparable part out of a date-like value, so a full date
// column (e.g. "2013-04-12") can be filtered/compared by year, quarter,
// month, or day without needing a separate discrete column in the dataset.

export function extractDatePart(rawValue, part) {

  if (!part) return rawValue;

  // Bare 4-digit year values (e.g. a "Year" column already stores 2013)
  // don't need Date parsing.
  if (part === "year" && /^\d{4}$/.test(String(rawValue).trim())) {
    return Number(rawValue);
  }

  const date = new Date(rawValue);

  if (isNaN(date.getTime())) {
    return null;
  }

  switch (part) {

    case "year":
      return date.getFullYear();

    case "month":
      return date.getMonth() + 1; // 1-12

    case "quarter":
      return Math.ceil((date.getMonth() + 1) / 3);

    case "day":
      return date.toISOString().slice(0, 10); // YYYY-MM-DD

    default:
      return null;
  }
}
